import { forEach, find } from "lodash";
const mapboxPolyline = require("@mapbox/polyline");

export const addPolylines = routes => {
  const newRoutes = [];
  forEach(routes, route => {
    const newRoute = { ...route };
    const polyline = newRoute.polyline;
    if (polyline) {
      const points = mapboxPolyline.decode(polyline);
      const pathCoordinate = points.map(x => {
        return { lat: x[0], lng: x[1] };
      });
      newRoute.pathCoordinate = pathCoordinate;
    }
    newRoutes.push(newRoute);
  });
  return newRoutes;
};

export const getStopLeft = (stopClicked, stops) => {
  if (stopClicked && stops?.length) {
    if (stopClicked.type === "pickup") {
      const stop = find(stops, s => s.orderId === stopClicked.orderId && s.type.toLowerCase() === "delivery");
      return stop;
    } else {
      const stop = find(stops, s => s.orderId === stopClicked.orderId && s.type.toLowerCase() === "pickup");
      return stop;
    }
  } else {
    return null;
  }
};
